<template>
  <el-card v-loading="loading">
    <div>......</div>
  </el-card>
</template>

<script>
import { getEId } from '@/api/mavin/promise.js';

export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    getEId() {
      this.loading = true;
      getEId().then(res => {
        this.loading = false;
        if (this.$route.params.action == 'last')
          this.$router.push(`/mavin/guide/base/${res}`);
        else this.$router.push(`/mavin/guide/promise/${res}`);
      });
    }
  },
  created() {
    this.getEId();
  }
};
</script>

<style></style>
